/**
 * Reloads the page once when a stale deployed chunk fails to load.
 */
export function reloadOnStaleChunk(): void {
  const KEY = "rl_chunk_reload_at";
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last <= 10000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // sessionStorage can be unavailable; reloading is still the safest recovery.
  }
  window.location.reload();
}
